"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Divider_st_css_1 = require("./Divider.st.css");
/**
 * Divider
 */
exports.Divider = function (props) {
    var children = props.children, vertical = props.vertical;
    var customDivider = !!children;
    return (React.createElement("div", { className: Divider_st_css_1.st(Divider_st_css_1.classes.root, { vertical: vertical && !customDivider, customDivider: customDivider }, props.className), "data-hook": props['data-hook'] }, children));
};
exports.Divider.displayName = 'Divider';
//# sourceMappingURL=Divider.js.map